import React, { useState } from 'react';

const HomepageBanner = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({
    type: '',
    text: '',
  });

  const openDialog = () => {
    setSubmitStatus({ type: '', text: '' });
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    setIsSubmitting(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', text: '' });

    try {
      const response = await fetch('/contact-form.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Unable to submit your request.');
      }

      setSubmitStatus({
        type: 'success',
        text: 'Thank you! We will contact you soon.',
      });
      setFormData({ name: '', phone: '', message: '' });
    } catch (error) {
      setSubmitStatus({
        type: 'error',
        text: error.message || 'Something went wrong. Please try again.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section className='hero-banner'>
        <div className='hero-banner__inner'>
          <div className='hero-banner__content'>
            <p className='hero-banner__subtitle'>
              INKJET &bull; LASER &bull; ALL-IN-ONE PRINTERS
            </p>
            <h1 className='hero-banner__title'>
              Find the Perfect Printer for Every Need
            </h1>
            <p className='hero-banner__desc'>
              Browse top-rated printers from trusted brands — whether it's for
              home, office, or high-volume work, we've got you covered with
              genuine products and hassle-free checkout.
            </p>
            <button
              type='button'
              className='hero-banner__btn'
              onClick={openDialog}
            >
              Contact Us
            </button>
            <div className='hero-banner__badges'>
              <a
                href='https://locator.hp.com/us/en/?ml___task=search_zip&ml___id=570276&ml___ml_skip_interstitial=1&ml___url_share_action=1&ml___lang=en-US%20(1)&ml___redirect_commercial_destination_Itemid=1'
                target='_blank'
              >
                <img
                  src='/images/hp-partner.png'
                  alt='HP'
                  style={{ height: 80 }}
                />
              </a>
              <div
                style={{
                  background: '#fff',
                  padding: '10px 20px',
                  borderRadius: '8px',
                }}
              >
                <a
                  href='https://www.trustpilot.com/review/itfixed247.com'
                  target='_blank'
                >
                  <img
                    src='/images/trustpilot.png'
                    alt='HP'
                    style={{ height: 45 }}
                  />
                </a>
              </div>
            </div>
          </div>
          <div className='hero-banner__image'>
            <img
              src='/images/404dn.jpeg'
              alt='Printer'
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
        </div>
      </section>

      {isDialogOpen && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
            zIndex: 1000,
          }}
          onClick={closeDialog}
        >
          <div
            style={{
              width: '100%',
              maxWidth: '520px',
              background: '#ffffff',
              borderRadius: '12px',
              padding: '24px',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 style={{ margin: '0 0 16px' }}>Contact Us</h2>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '12px' }}>
                <label
                  htmlFor='name'
                  style={{ display: 'block', marginBottom: '6px' }}
                >
                  Name
                </label>
                <input
                  id='name'
                  name='name'
                  type='text'
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                  }}
                />
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label
                  htmlFor='phone'
                  style={{ display: 'block', marginBottom: '6px' }}
                >
                  Phone
                </label>
                <input
                  id='phone'
                  name='phone'
                  type='tel'
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                  }}
                />
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label
                  htmlFor='message'
                  style={{ display: 'block', marginBottom: '6px' }}
                >
                  Message
                </label>
                <textarea
                  id='message'
                  name='message'
                  value={formData.message}
                  onChange={handleInputChange}
                  rows={4}
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                  }}
                />
              </div>

              {submitStatus.text && (
                <p
                  style={{
                    color:
                      submitStatus.type === 'error' ? '#b91c1c' : '#166534',
                    margin: '0 0 12px',
                  }}
                >
                  {submitStatus.text}
                </p>
              )}

              <div
                style={{
                  display: 'flex',
                  gap: '10px',
                  justifyContent: 'flex-end',
                }}
              >
                <button
                  type='button'
                  onClick={closeDialog}
                  style={{
                    padding: '10px 14px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    background: '#fff',
                  }}
                >
                  Close
                </button>
                <button
                  type='submit'
                  disabled={isSubmitting}
                  style={{
                    padding: '10px 14px',
                    borderRadius: '6px',
                    border: 'none',
                    background: '#111827',
                    color: '#fff',
                    cursor: isSubmitting ? 'not-allowed' : 'pointer',
                    opacity: isSubmitting ? 0.7 : 1,
                  }}
                >
                  {isSubmitting ? 'Sending...' : 'Submit'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default HomepageBanner;
